import axios from "../axios";

// 社区街道code
export const get_qy_street = (params) => {
    return axios('get', '/api/street/get_qy_street', params);
}